import { render, staticRenderFns } from "./OfferDetailCredentials.vue?vue&type=template&id=06e7c763"
import script from "./OfferDetailCredentials.vue?vue&type=script&lang=js"
export * from "./OfferDetailCredentials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports